const DEFAULT_PRICE_INCREMENT_PERCENTAGE = 10;

export default DEFAULT_PRICE_INCREMENT_PERCENTAGE;
